import React from 'react';
import {Link} from 'react-router-dom';
import {
  fetchTaxonomy,
  sendGoogleAnalytics,
} from 'sections/services-marketplace/experts/utilities';
import {Card, Caption, TextStyle, Heading} from '@shopify/polaris';
import {
  GoogleAnalyticsEventActions,
  GoogleAnalyticsEventCategories,
  GoogleAnalyticsEventType,
} from '../../utilities/constants';

import styles from './ServiceCardContainer.scss';

interface OwnProps {
  serviceHandle: string;
  label: string;
  imageSrc?: string;
  imageSrcSet?: string;
  link: string;
  children: React.ReactNode;
}

export default function ServiceCardContainer({
  serviceHandle,
  label,
  imageSrc,
  imageSrcSet,
  link,
  children,
}: OwnProps) {
  const taxonomy = fetchTaxonomy();
  const ancestors = taxonomy.getAncestors(serviceHandle);

  const onServiceClick = () => {
    sendGoogleAnalytics({
      type: GoogleAnalyticsEventType.Event,
      payload: {
        eventCategory: GoogleAnalyticsEventCategories.user,
        eventAction: GoogleAnalyticsEventActions.serviceCardClick,
        eventLabel: serviceHandle,
      },
    });
  };

  return (
    <div className={styles.CardContainer}>
      <Link to={link} onClick={onServiceClick}>
        <Card>
          {imageSrc && (
            <div className={styles.ImageContainer}>
              <img
                className={styles.Image}
                src={imageSrc}
                srcSet={imageSrcSet}
                alt={label}
              />
            </div>
          )}
          <div className={styles.CardSection}>
            {ancestors.length > 0 && (
              <div className={styles.Ancestor}>
                <Caption>
                  <TextStyle variation="subdued">
                    {ancestors.slice(-1)[0].shortLabel}
                  </TextStyle>
                </Caption>
              </div>
            )}
            <Heading element="h3">
              <TextStyle variation="strong">{label}</TextStyle>
            </Heading>
            <div className={styles.CardContent}>{children}</div>
          </div>
        </Card>
      </Link>
    </div>
  );
}
